define(
	'ProductDetails.Full.View.Site'
,	[
        'ProductDetails.Full.View'
	,	'ProductDetails.Base.View'
	,	'SC.Configuration'

	,	'ItemRelations.Related.View'
	,	'ItemRelations.Correlated.View'

	,	'ProductDetails.Information.View'

	,	'SocialSharing.Flyout.View'

	,	'product_details_full.tpl'

	,	'underscore'
	,	'Tracker'

	]
,	function (
        View
	,	ProductDetailsBaseView
	,	Configuration

	,	ItemRelationsRelatedView
	,	ItemRelationsCorrelatedView

	,	ProductDetailsInformationView

	,	SocialSharingFlyoutView

	,	product_details_full_tpl

	,	_
	,	Tracker
	)
{
	'use strict';

    _.extend(View.prototype, {
        getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;

            var addtlImgUrl = self.model.get('item').get('custitemar_url') || '';

            return _.extend(context, {
                addtlImgUrl : addtlImgUrl,
                showAddtlImage : addtlImgUrl.length > 0 ? true : false
            });
        })
    });
});

